<div class="menu">
  <ng-content></ng-content>
</div>
